import React from "react";
import SellerProfile from "./SellerProfile";

export default function ProfileSection() {
  return <SellerProfile />;
}
